import clefClubImage from "../../../../content/featured/ClefClub/ClefClub.png";
import homePage from "../../../../content/blogs/ClefClub/homepage.png";
import newJamPage from "../../../../content/blogs/ClefClub/new-jam-page.jpg";
import myPage from "../../../../content/blogs/ClefClub/my-page.png";
import addToJamPage from "../../../../content/blogs/ClefClub/add-to-jam-page.png";
import viewPage from "../../../../content/blogs/ClefClub/view-page.png";
import searchPage from "../../../../content/blogs/ClefClub/search-page.png";
import jamApproval from "../../../../content/blogs/ClefClub/jam-approval.png";
import qualityControl from "../../../../content/blogs/ClefClub/quality-control.jpg";
import socialInteractions1 from "../../../../content/blogs/ClefClub/social-interactions-1.jpg";
import socialInteractions2 from "../../../../content/blogs/ClefClub/social-interactions-2.jpg";
import userDemographics from "../../../../content/blogs/ClefClub/user-demographics.png";
import userPreference from "../../../../content/blogs/ClefClub/user-preference.png";
import userExperience from "../../../../content/blogs/ClefClub/user-experience.png";
import * as React from 'react';
export default {
  clefClubImage,
  homePage,
  newJamPage,
  myPage,
  addToJamPage,
  viewPage,
  searchPage,
  jamApproval,
  qualityControl,
  socialInteractions1,
  socialInteractions2,
  userDemographics,
  userPreference,
  userExperience,
  React
};